import React from 'react';
import { useAuth } from '../context/AuthContext';
import { NOTES_APP_URL } from '../components/Sidebar';
import { Icon } from '../components/ui';

// Caregivers do their work in the Progress Notes app. The operations platform is for administrators.
export default function AdminsOnlyPage() {
  const { user, logout } = useAuth();
  return (
    <div className="ops-gate">
      <div className="ops-gate__card">
        <div className="ops-gate__mark">H</div>
        <h1>This platform is for administrators</h1>
        <p>
          {user?.firstName ? `Hi ${user.firstName}. ` : ''}
          Progress notes, AI Agent Notes and AI Agent T&amp;A live in the Progress Notes app.
          Open it to continue your work.
        </p>
        <div className="ops-gate__actions">
          <a href={NOTES_APP_URL} className="ops-btn ops-btn--primary">
            <Icon name="external" /> Open the Progress Notes app
          </a>
          <button type="button" className="ops-btn" onClick={logout}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
